<template>
    <div id="modal-private-info" class="modal fade">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="list-group list-group-flush">
                        <li v-if="item.first_kana" class="list-group-item border-0 p-0">
                            <form-item lab="氏名フリガナ">{{item.first_kana}}　{{item.last_kana}}</form-item>
                            <form-item lab="氏名">{{item.first_nm}}　{{item.last_nm}}</form-item>
                            <form-item lab="性別">{{item.gender == '0' ? '男' : '女'}}</form-item>
                            <form-item lab="年齢">{{getAge(item.year, item.month, item.day)}}歳</form-item>
                            <form-item lab="生年月日">{{item.year}}年{{item.month}}月{{item.day}}日</form-item>
                            <form-item lab="郵便番号〒">{{item.user_zipcode}}</form-item>
                            <form-item lab="住所">{{item.user_address1 + item.user_address2 + item.user_address3}}</form-item>
                            <form-item lab="電話番号(携帯)">{{item.phone}}</form-item>
                            <form-item lab="契約種類">{{converVal('contract',item.contract)}}</form-item>

                            <div v-if="item.contract == '1'">
                                <span class="text-danger">
                                    <small>
                                        <i class="fas fa-exclamation-circle"></i>
                                        会社情報
                                    </small>
                                </span>
                                <hr>
                                <form-item lab="会社名">{{item.company_nm}}</form-item>
                                <form-item lab="郵便番号〒">{{item.company_zipcode}}</form-item>
                                <form-item lab="住所">{{item.company_address1 + item.company_address2 + item.company_address3}}</form-item>
                                <form-item v-if ="item.company_url" lab="会社ホームページURL">{{item.company_url}}</form-item>
                                <form-item lab="営業担当(氏名)">{{item.first_nm_sales}}　{{item.last_nm_sales}}</form-item>
                                <form-item lab="営業担当(氏名フリガナ)">{{item.first_kana_sales}}　{{item.last_kana_sales}}</form-item>
                                <form-item lab="営業担当(携帯)">{{item.sales_phone}}</form-item>
                                <form-item lab="営業担当(メール)">{{item.sales_mail}}</form-item>
                            </div>
                        </li>
                        <li v-else class="list-group-item border-0">個人情報は登録されていません。</li>
                    </ul>
                </div>
                <div class="modal-footer justify-content-center">
                    <button class="btn btn-primary" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormItem from './PrivateLayout'
    import {converVal} from 'pages/commons/form/selectList'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            FormItem
        },
        data() {
            return {
                item: {}
            }
        },
        watch: {
            getPrivateInfo (info) {
                this.item = info
            },
            getPrivateInfoLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('doneSpinner')
                    this.showThis()
                }
                if (status == 1) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            ...mapGetters(['getPrivateInfo', 'getPrivateInfoLoadStatus'])
        },
        methods: {
            loadPrivateInfo (id) {
                this.$store.dispatch('loadPrivateInfo', {
                    userId: id
                })
            },
            getAge (year, month, day) {
                let birthday = this.$moment(year + month + day)
                return this.$moment().diff(birthday,'years')
            },
            converVal (name, val) {
                return converVal(name,val)
            },
            openThis (userId) {
                this.loadPrivateInfo(userId)
            },
            showThis () {
                $('#modal-private-info').modal('show')
            },
            hideThis () {
                $('#modal-private-info').modal('hide')
            },
            resetThis () {
                //this.item = {}
            },
        }
    }
</script>

<style>

</style>
